import Link from "next/link";
import styles from "./LinkButton.module.scss";

export default function LinkButton({ url, text }) {
	return (
		<Link href={url}>
			<a className={styles.linkButton}>
				<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
					<path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
				</svg>
				{text}
			</a>
		</Link>
	);
}
